import React from "react";

const MediaIcon: React.FC = () => {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="24.5"
        cy="24"
        r="23.7"
        fill="#D2EEFF"
        stroke="#D4D6D9"
        strokeWidth="0.6"
      />
      <path
        d="M17.8333 15.334C17.8333 14.5383 18.1494 13.7753 18.712 13.2127C19.2746 12.6501 20.0377 12.334 20.8333 12.334H32.8333C33.629 12.334 34.392 12.6501 34.9547 13.2127C35.5173 13.7753 35.8333 14.5383 35.8333 15.334V27.334C35.8333 28.1296 35.5173 28.8927 34.9547 29.4553C34.392 30.0179 33.629 30.334 32.8333 30.334H30.5V32.6673C30.5 33.463 30.1839 34.226 29.6213 34.7886C29.0587 35.3512 28.2956 35.6673 27.5 35.6673H15.5C14.7044 35.6673 13.9413 35.3512 13.3787 34.7886C12.8161 34.226 12.5 33.463 12.5 32.6673V20.6673C12.5 19.8717 12.8161 19.1086 13.3787 18.546C13.9413 17.9834 14.7044 17.6673 15.5 17.6673H17.8333V15.334ZM28.5 20.6673C28.5 20.4021 28.3946 20.1477 28.2071 19.9602C28.0196 19.7727 27.7652 19.6673 27.5 19.6673H15.5C15.2348 19.6673 14.9804 19.7727 14.7929 19.9602C14.6054 20.1477 14.5 20.4021 14.5 20.6673V29.9233L22.0573 26.006C22.6061 25.7212 23.2295 25.6129 23.8421 25.696C24.4548 25.7791 25.0268 26.0494 25.48 26.47L28.5 29.2753V20.6673ZM14.5 32.6673C14.5 33.2193 14.948 33.6673 15.5 33.6673H27.5C27.7652 33.6673 28.0196 33.562 28.2071 33.3744C28.3946 33.1869 28.5 32.9325 28.5 32.6673V32.0047L24.1187 27.9366C23.9678 27.7964 23.7774 27.7062 23.5733 27.6783C23.3693 27.6503 23.1616 27.6861 22.9787 27.7807L14.5 32.1766V32.6673ZM19.8333 17.6673H27.5C28.2956 17.6673 29.0587 17.9834 29.6213 18.546C30.1839 19.1086 30.5 19.8717 30.5 20.6673V28.334H32.8333C33.0985 28.334 33.3529 28.2286 33.5404 28.0411C33.728 27.8536 33.8333 27.5992 33.8333 27.334V15.334C33.8333 15.0688 33.728 14.8144 33.5404 14.6269C33.3529 14.4393 33.0985 14.334 32.8333 14.334H20.8333C20.5681 14.334 20.3138 14.4393 20.1262 14.6269C19.9387 14.8144 19.8333 15.0688 19.8333 15.334V17.6673Z"
        fill="#009EEC"
      />
    </svg>
  );
};

export default MediaIcon;
